import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  OnDestroy,
  signal,
  viewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BaseFilterItem } from '@modules/filter/directives/base-filter-item.directive';
import { FILTER_ITEM } from '@modules/filter/utils/token';
import { FilterBean, FilterRow } from '@type/filter.type';
import { FDateComponent } from '../f-date/f-date.component';
import { FReferenceComponent } from '../f-reference/f-reference.component';
import { FSelectComponent } from '../f-select/f-select.component';
import { FTextComponent } from '../f-text/f-text.component';
import { FUserComponent } from '../f-user/f-user.component';

@Component({
  selector: 'app-filter-row',
  imports: [MatIconModule, FTextComponent, FDateComponent, FSelectComponent, FReferenceComponent, FUserComponent],
  templateUrl: './filter-row.component.html',
  styleUrl: './filter-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterRowComponent implements OnDestroy {
  private attrObserver?: MutationObserver;

  row = input.required<FilterRow>();

  content = viewChild<BaseFilterItem<FilterBean>>(FILTER_ITEM);

  details = viewChild<ElementRef<HTMLDetailsElement>>('details');

  detailsOpen = signal(false);

  constructor() {
    effect(() => {
      const details = this.details()?.nativeElement;
      if (details) {
        this.observe(details);
      }
    });
  }

  ngOnDestroy(): void {
    this.attrObserver?.disconnect();
  }

  getContent() {
    return this.content;
  }

  private observe(details: HTMLDetailsElement) {
    this.attrObserver = new MutationObserver((mutations) => {
      mutations.filter((m) => m.attributeName === 'open');

      this.detailsOpen.set(details.open);

      if (details.open) {
        details.scrollIntoView({ behavior: 'smooth' });
      }
    });
    this.attrObserver.observe(details, { attributes: true });
  }
}
